import axiosLocal from '@/services/rest/index';
import { buildClientApiConfig } from '@/helpers/apiRequestConfig';

export const graphQLRequest = {
    async postQuery(query: any, selectedType: string): Promise<any[]> {
        const options = buildClientApiConfig({
            'Content-Type': 'application/json',
            'X-Report-Format': selectedType,
        });

        return axiosLocal
            .post(`/graphql`, query, {
                ...options,
                responseType: selectedType === 'json' ? 'json' : 'blob',
            })
            .then((response: any) => {
                return response.data;
            });
    },
};
